import { AnimationObject } from 'lottie-react-native';

type LottieKey = 'confetti';

const lottie: { [key in LottieKey]: AnimationObject } = {
  confetti: require('./confetti.json'),
} as const;

export default lottie;
